import { VisibleToModal } from "./VisibleToModal";

export default VisibleToModal;
